export default __webpack_public_path__ + "static/media/chevron_white.b20cb121.svg";